var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { resolveStrokeWidth, strokeContextForCanvas, getActiveDiagram } from '../theme';
import { autoLayoutNodesResponsive, createDiagramGroup, normalizeDiagramData, readCanvasSize, separateOverlappingNodes, } from '../helpers';
import { createFlowchartNode, } from '../primitives';
import { collectObstacles } from '../router';
import { connectNodePairs } from '../connectors';
import { maybeApplyDiagramFlow } from '../flow';
/** Create a flowchart from node/edge data */
export function createFlowchart(app, data, options) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var _e, _f, _g;
    if (options === void 0) { options = {}; }
    var group = createDiagramGroup(app, 'flowchart', __assign(__assign({}, options), { data: data }), { name: 'flowchart' });
    var _h = normalizeDiagramData(data), nodes = _h.nodes, edges = _h.edges;
    var canvas = readCanvasSize(options);
    var strokeCtx = strokeContextForCanvas(canvas.width, canvas.height);
    var edgeWidth = resolveStrokeWidth(getActiveDiagram().stroke.edge, strokeCtx);
    autoLayoutNodesResponsive(nodes, canvas.width, canvas.height, 128, 52);
    var nodeMap = new Map();
    try {
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var n = nodes_1_1.value;
            var nodeGroup = createFlowchartNode(app, n.label, (_e = n.type) !== null && _e !== void 0 ? _e : 'process');
            nodeGroup.x = (_f = n.x) !== null && _f !== void 0 ? _f : 0;
            nodeGroup.y = (_g = n.y) !== null && _g !== void 0 ? _g : 0;
            if (typeof n.rotation === 'number')
                nodeGroup.rotation = n.rotation;
            nodeGroup.metadata = __assign(__assign({}, nodeGroup.metadata), { diagramId: n.id });
            nodeMap.set(n.id, nodeGroup);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    separateOverlappingNodes(__spreadArray([], __read(nodeMap.values()), false), {
        gap: 20,
        canvasW: canvas.width,
        canvasH: canvas.height,
    });
    var edgeLayer = app.group({ zIndex: -10, listening: false });
    edgeLayer.metadata.diagramEdgeLayer = true;
    var allNodes = __spreadArray([], __read(nodeMap.values()), false);
    var obstacles = collectObstacles(allNodes);
    var pairs = [];
    try {
        for (var edges_1 = __values(edges), edges_1_1 = edges_1.next(); !edges_1_1.done; edges_1_1 = edges_1.next()) {
            var edge = edges_1_1.value;
            var fromNode = nodeMap.get(edge.from);
            var toNode = nodeMap.get(edge.to);
            if (!fromNode || !toNode)
                continue;
            pairs.push({
                from: fromNode,
                to: toNode,
                options: {
                    label: edge.label,
                    edgeId: "".concat(edge.from, "->").concat(edge.to),
                    fromId: edge.from,
                    toId: edge.to,
                },
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (edges_1_1 && !edges_1_1.done && (_b = edges_1.return)) _b.call(edges_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var _j = __values(connectNodePairs(app, pairs, {
            parent: group,
            obstacleNodes: allNodes,
            obstacles: obstacles,
            stroke: getActiveDiagram().edge,
            glowColor: getActiveDiagram().edgeGlow,
            glow: false,
            strokeWidth: edgeWidth,
            cornerRadius: 10,
            style: 'smart',
        })), _k = _j.next(); !_k.done; _k = _j.next()) {
            var g = _k.value;
            edgeLayer.add(g);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
        }
        finally { if (e_3) throw e_3.error; }
    }
    group.add(edgeLayer);
    try {
        for (var _l = __values(nodeMap.values()), _m = _l.next(); !_m.done; _m = _l.next()) {
            var nodeGroup = _m.value;
            group.add(nodeGroup);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
        }
        finally { if (e_4) throw e_4.error; }
    }
    maybeApplyDiagramFlow(app, group, options);
    return group;
}
